module.exports = __webpack_public_path__ + "img/linkedin.5457a751.svg";